// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Oum-","line":"_1wWvn"};